import styled from "styled-components";

export const MainWrapper = styled.div`
  min-height: 100vh;
  background: #f8f9fa;
  padding: 2rem 0;
`;

export const MainContent = styled.div`
  background: white;
  border-radius: 10px;
  padding: 2rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  
  legend {
    font-size: 1.5rem;
    color: #2c3e50;
    margin-bottom: 0.5rem;
  }
`;

export const DropzoneContainer = styled.div`
  border: 2px dashed ${props => 
    props.disabled ? '#dee2e6' :
    props.isDragActive ? '#007bff' : 
    props.isDragReject ? '#dc3545' : '#ced4da'
  };
  border-radius: 10px;
  padding: 3rem 2rem;
  text-align: center;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: all 0.3s ease;
  background: ${props => 
    props.disabled ? '#f8f9fa' :
    props.isDragActive ? '#e3f2fd' : 
    props.isDragReject ? '#ffebee' : 'white'
  };
  opacity: ${props => props.disabled ? 0.7 : 1};

  &:hover {
    border-color: ${props => 
      props.disabled ? '#dee2e6' :
      props.isDragReject ? '#dc3545' : '#007bff'
    };
    background: ${props => 
      props.disabled ? '#f8f9fa' :
      props.isDragReject ? '#ffebee' : '#f8f9fa'
    };
  }

  p {
    margin: 0.5rem 0;
    color: ${props => 
      props.isDragReject ? '#dc3545' : '#6c757d'
    };
  }

  strong {
    color: ${props => 
      props.isDragReject ? '#dc3545' : '#007bff'
    };
  }

  .fa-image, .fa-cloud-upload-alt {
    color: ${props => 
      props.isDragActive ? '#007bff' : 
      props.isDragReject ? '#dc3545' : '#6c757d'
    };
  }
`;